import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65573c31"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-4\" data-v-65573c31><div class=\"w-16 h-16 bg-primary-100 rounded-lg\" data-v-65573c31></div><div class=\"flex-1\" data-v-65573c31><div class=\"h-5 bg-primary-100 rounded w-1/3 mb-2\" data-v-65573c31></div><div class=\"h-4 bg-primary-50 rounded w-2/3 mb-2\" data-v-65573c31></div><div class=\"h-4 bg-primary-50 rounded w-1/2\" data-v-65573c31></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "bg-white rounded-xl border border-primary-200 p-12 text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-16 mx-auto text-primary-300 mb-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-primary-700 mb-2" }, " No Upcoming Events ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, "Check back soon for community happenings!", -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_10 = { class: "flex gap-2 mb-4" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex flex-col sm:flex-row" }
const _hoisted_13 = {
  key: 0,
  class: "sm:w-48 h-32 sm:h-auto flex-shrink-0"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "flex-1 p-5" }
const _hoisted_16 = { class: "flex items-start gap-4" }
const _hoisted_17 = { class: "text-xs font-medium uppercase" }
const _hoisted_18 = { class: "text-xl font-bold leading-none" }
const _hoisted_19 = { class: "flex-1 min-w-0" }
const _hoisted_20 = { class: "flex items-center gap-2 mb-1 flex-wrap" }
const _hoisted_21 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full"
}
const _hoisted_22 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-600 rounded-full"
}
const _hoisted_23 = {
  key: 2,
  class: "px-2 py-0.5 text-xs font-medium bg-green-100 text-green-700 rounded-full"
}
const _hoisted_24 = {
  key: 3,
  class: "px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 rounded-full capitalize"
}
const _hoisted_25 = { class: "font-semibold text-primary-800 mb-1" }
const _hoisted_26 = { class: "text-sm text-primary-500 mb-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-300 flex-shrink-0 hidden sm:block",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))

import { ref, computed, onMounted } from "vue";
import { HoodApi } from "@/services/HoodApi";
import EventDetailModal from "./EventDetailModal.vue";
import { sanitizeHtml } from "@/utils/sanitize";

interface CombinedEvent {
  id: string | number;
  title: string;
  description?: string;
  date: string;
  end_date?: string;
  time?: string;
  venue?: string;
  location?: string;
  url?: string;
  image?: string;
  image_url?: string;
  attachment?: string;
  type?: string;
  source_name?: string;
  isNeighborhood: boolean;
  isRecurring?: boolean;
  recurringDay?: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(true);
const hoaEvents = ref<CombinedEvent[]>([]);
const localEvents = ref<CombinedEvent[]>([]);
const filter = ref<"all" | "hoa" | "local">("all");
const selectedEvent = ref<CombinedEvent | null>(null);

// Parse date string as local time (not UTC) - defined early for use in computed
const parseLocalDate = (dateStr: string | null | undefined) => {
  if (!dateStr) return new Date();
  return new Date(dateStr.replace(/-/g, "/"));
};

// Compute the next occurrence for recurring events based on recurring_day
const computeNextOccurrence = (
  recurringDay: string | null | undefined
): string | null => {
  if (!recurringDay) return null;

  const dayMap: Record<string, number> = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const targetDay = dayMap[recurringDay.toLowerCase()];
  if (targetDay === undefined) return null;

  const today = new Date();
  const currentDay = today.getDay();

  // Calculate days until next occurrence
  let daysUntil = targetDay - currentDay;
  if (daysUntil < 0) {
    daysUntil += 7; // Next week
  } else if (daysUntil === 0) {
    // Today is the day - check if we should show today or next week
    // For simplicity, show today
  }

  const nextDate = new Date(today);
  nextDate.setDate(today.getDate() + daysUntil);

  // Format as YYYY-MM-DD
  const year = nextDate.getFullYear();
  const month = String(nextDate.getMonth() + 1).padStart(2, "0");
  const day = String(nextDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const allEvents = computed(() => {
  const combined = [...hoaEvents.value, ...localEvents.value];
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Start of today

  // Filter out past events and events with no date, then sort by date (soonest first)
  return combined
    .filter((e) => {
      if (!e.date) return false;
      const eventDate = parseLocalDate(e.date);
      return eventDate >= today;
    })
    .sort(
      (a, b) =>
        parseLocalDate(a.date).getTime() - parseLocalDate(b.date).getTime()
    );
});

// Filter function to exclude past events
const filterUpcoming = (events: CombinedEvent[]) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return events
    .filter((e) => e.date && parseLocalDate(e.date) >= today)
    .sort(
      (a, b) =>
        parseLocalDate(a.date).getTime() - parseLocalDate(b.date).getTime()
    );
};

const upcomingHoaEvents = computed(() => filterUpcoming(hoaEvents.value));
const upcomingLocalEvents = computed(() => filterUpcoming(localEvents.value));

const filteredEvents = computed(() => {
  if (filter.value === "hoa") return upcomingHoaEvents.value;
  if (filter.value === "local") return upcomingLocalEvents.value;
  return allEvents.value;
});

const formatMonth = (dateStr: string | null | undefined) => {
  if (!dateStr) return "---";
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString("en-US", { month: "short" });
};

const formatDay = (dateStr: string | null | undefined) => {
  if (!dateStr) return "--";
  const date = parseLocalDate(dateStr);
  return date.getDate();
};

const formatFullDate = (dateStr: string | null | undefined) => {
  if (!dateStr) return "Date TBD";
  const date = parseLocalDate(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const truncateHtml = (html: string, maxLength: number) => {
  // Sanitize first, then strip HTML to get plain text for preview
  const sanitized = sanitizeHtml(html);
  const text = sanitized.replace(/<[^>]*>/g, "");
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "...";
};

const fetchEvents = async () => {
  try {
    // Fetch HOA events and local events in parallel
    const [hoaData, localResponse] = await Promise.all([
      HoodApi.fetch_events(),
      HoodApi.fetch_local_events({ limit: 50, scope: "local" }).catch((err) => {
        console.warn("Failed to fetch local events:", err);
        return { ok: false, data: [] };
      }),
    ]);

    // Map HOA events
    hoaEvents.value = (hoaData || []).map((event: any) => ({
      id: `hoa-${event.id}`,
      title: event.title,
      description: event.description,
      date: event.starting_date,
      end_date: event.ending_date,
      time: event.start_time ? formatTime(event.start_time) : undefined,
      location: event.location || "Foxwood Crossing",
      url: event.link,
      image: event.image,
      attachment: event.attachment,
      isNeighborhood: true,
    }));

    // Map local events
    if (localResponse.ok && localResponse.data) {
      localEvents.value = localResponse.data.map((event: any) => {
        // Determine the event date:
        // 1. Use explicit date if available
        // 2. For recurring events without a date, compute next occurrence
        let eventDate = event.date;

        if (!eventDate && event.recurring && event.recurring_day) {
          eventDate = computeNextOccurrence(event.recurring_day);
        }

        return {
          id: `local-${event.id}`,
          title: event.title,
          description: event.description,
          date: eventDate,
          end_date: event.end_date,
          time: event.time || event.start_time,
          venue: event.venue_name,
          location: event.venue_name,
          url: event.link,
          image_url: event.image_url,
          type: event.type,
          source_name: event.source_name,
          isNeighborhood: false,
          isRecurring: !!event.recurring,
          recurringDay: event.recurring_day,
        };
      });
    }
  } catch (err) {
    console.error("Failed to fetch events:", err);
  } finally {
    loading.value = false;
  }
};

const formatTime = (timeStr: string) => {
  const [hours, minutes] = timeStr.split(":");
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

onMounted(() => {
  fetchEvents();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "bg-white rounded-xl border border-primary-200 p-6 animate-pulse"
            }, _hoisted_3)
          }), 64))
        ]))
      : (_unref(allEvents).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (filter.value = 'all')),
                class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
            filter.value === 'all'
              ? 'bg-accent-600 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-50 border border-primary-200'
          ])
              }, " All Events (" + _toDisplayString(_unref(allEvents).length) + ") ", 3),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (filter.value = 'hoa')),
                class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
            filter.value === 'hoa'
              ? 'bg-accent-600 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-50 border border-primary-200'
          ])
              }, " HOA (" + _toDisplayString(_unref(upcomingHoaEvents).length) + ") ", 3),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (filter.value = 'local')),
                class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-lg transition-colors", 
            filter.value === 'local'
              ? 'bg-accent-600 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-50 border border-primary-200'
          ])
              }, " Local (" + _toDisplayString(_unref(upcomingLocalEvents).length) + ") ", 3)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredEvents), (event) => {
              return (_openBlock(), _createElementBlock("div", {
                key: event.id,
                onClick: ($event: any) => (selectedEvent.value = event),
                class: "bg-white rounded-xl border border-primary-200 shadow-soft overflow-hidden cursor-pointer hover:shadow-md hover:border-primary-300 transition-all"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (event.image || event.image_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: event.image || event.image_url,
                          alt: event.title,
                          class: "w-full h-full object-cover"
                        }, null, 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-14 h-14 rounded-lg flex flex-col items-center justify-center flex-shrink-0", 
                  event.isNeighborhood
                    ? 'bg-accent-100 text-accent-700'
                    : 'bg-primary-100 text-primary-600'
                ])
                      }, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(formatMonth(event.date)), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(formatDay(event.date)), 1)
                      ], 2),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (event.isNeighborhood)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, " HOA "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, " Local ")),
                          (event.isRecurring)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Weekly "))
                            : _createCommentVNode("", true),
                          (event.type && event.type !== 'event')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(event.type), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("h3", _hoisted_25, _toDisplayString(event.title), 1),
                        _createElementVNode("p", _hoisted_26, [
                          (event.time)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(event.time) + " · ", 1))
                            : _createCommentVNode("", true),
                          (event.venue || event.location)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(event.venue || event.location), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatFullDate(event.date)), 1))
                        ]),
                        (event.description)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "text-sm text-primary-600 line-clamp-2",
                              innerHTML: truncateHtml(event.description, 150)
                            }, null, 8, _hoisted_30))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_31
                    ])
                  ])
                ])
              ], 8, _hoisted_11))
            }), 128))
          ])),
    _createVNode(EventDetailModal, {
      event: selectedEvent.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (selectedEvent.value = null))
    }, null, 8, ["event"])
  ]))
}
}

})